import {
    Hydrate,
    QueryClient,
    QueryClientProvider,
} from '@tanstack/react-query';
import { hydrate } from 'hide-in-shadows';
import React from 'react';
import { App } from './App';
import type { InitialState } from './AppConfig';

hydrate('search-newfrontier-podlet', HydratedApp);

type HydratedAppProps = InitialState & {
    reactQueryState: unknown;
};

function HydratedApp(props: HydratedAppProps) {
    const { reactQueryState, ...appProps } = props;

    const queryClient = new QueryClient({
        defaultOptions: {
            queries: {
                refetchOnWindowFocus: false,
            },
        },
    });

    return (
        <QueryClientProvider client={queryClient}>
            <Hydrate state={reactQueryState}>
                <App {...appProps} />
            </Hydrate>
        </QueryClientProvider>
    );
}

// // eslint-disable-next-line @typescript-eslint/no-explicit-any
// function hasRequiredAndValidState(attributes: any) {
//     const hasRequiredState = Object.keys(initialStateTypeMap).every(
//         (key) => key in attributes,
//     );
//     const hasValidState = Object.entries(attributes).every(([key, value]) => {
//         return (
//             value !== 'undefined' &&
//             typeof value === typeof initialStateTypeMap[key as InitialStateKey]
//         );
//     });
//     return hasRequiredState && hasValidState;
// }
